'use client';

import 'ckeditor5/ckeditor5.css';
import styles from './terms.module.scss';
import { useContext } from 'react';
import { GlobalContext } from 'context';
const TermsComp: React.FC<{
  content: string;
}> = props => {
  const lang = useContext(GlobalContext).langText.terms;
  return <div className={`${styles.terms} m-auto`} data-sentry-component="TermsComp" data-sentry-source-file="terms.index.tsx">
            <h2 className="t-h2 mb-4 t-800 t-dark1">{lang.title}</h2>
            <div className="ck-content" dangerouslySetInnerHTML={{
      __html: props.content
    }}></div>
        </div>;
};
export default TermsComp;